import { BonusCategoriesTranslations } from "./bonus-categories-pt-br";

export const BONUS_CATEGORIES_EN_US: BonusCategoriesTranslations = {
	title: "Bonus Categories",
	notification: {
		create: "Bonus category successfully created",
		edit: "Bonus category successfully edited",
		changeStatus: "Bonus category successfully changed",
		delete: "Bonus category successfully deleted",
	},
	delete: {
		title: "Delete Bonus Category",
		subtitle: "Are you sure you want to delete this bonus category?",
		confirm: "Yes, delete",
		cancel: "Cancel",
	},
	header: {
		create: "New Bonus Category",
		edit: "Edit Bonus Category",
		search: "Search for...",
		changeStatus: "Change Status",
		delete: "Delete Bonus Category",
	},
	list: {
		title: "Bonus Categories",
		emptyState: {
			title: "No bonus categories found",
			description: "Create a new bonus category to start",
		},
		status: {
			label: "Status",
			active: "Active",
			inactive: "Inactive",
		},
		category: "Category",
		productsCategories: "Products Categories",
		products: "Products",
		isLockZigTag: {
			label: "Usage on the card",
			tooltip:
				"When active, the cashless card will only work with the bonus balance of this category, blocking other balances and bonus categories.",
			active: "Only this bonus",
			inactive: "Bonus and charges",
		},
		employees: "Authorized",
		daysToExpire: "Expiration",
		days: "days",
		trash: "Delete",
		options: {
			label: "Actions",
			edit: "Edit Category",
			inactive: "Deactivate Category",
			active: "Activate Category",
		},
	},
	form: {
		name: {
			label: "Category name",
			required: "Name is required",
			placeholder: "Enter category name",
			maxLength: "Maximum of 30 characters",
		},
		daysToExpire: {
			label: "Bonus validity",
			required: "Required field",
			placeholder: "Days",
			positive: "Days to expire must be a positive number",
			maxValue: "Maximum is 365 days",
		},
		employees: {
			label: "Authorized employees",
			placeholder: "Select Employees",
			validation: "Select at least one employee",
		},
		categories: {
			label: "Categories that can be used with the bonus",
			placeholder: "Select Categories",
			tooltip: "The limitation will be applied only on the pre-paid operation",
		},
		products: {
			label: "Products that can be purchased with the bonus",
			placeholder: "Select Products",
			tooltip: "The limitation will be applied only on the pre-paid operation",
		},
		lockZigTag: {
			label: "Does not allow other types of balance on the card",
			tooltip: "When active, the cashless card will only work with the bonus balance of this category, blocking other balances and bonus categories.",
		},
	},
};
